import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { NameContext } from "../context/NameContext";

const PUBLIC_PATHS = [
  "/",
  "/zenlab2",
  "/blog",
  "/post/",
  "/datenschutz",
  "/impressum",
  "/login",
  "/register",
  "/contact",
  "/forgot-password",
  "/reset-password",
  "/adminresetpassword",
  "/loginadmin",
  "/admindashboard",
  "/courses",
  "/coursecockpit"
];

const NameGuard = ({ children }) => {
  const { isNameEntered, isLoading } = useContext(NameContext);
  const location = useLocation();

  // Query-Parameter holen
  const params = new URLSearchParams(location.search);
  const userParam = params.get("user");
  const isDemo = userParam === "999";

  // Check: Ist die Route öffentlich?
  const isPublic = PUBLIC_PATHS.some((path) =>
    location.pathname.startsWith(path)
  );

  // Ladeanzeige, falls Kontext noch lädt
  if (isLoading) return null; // Optional: Spinner/Loader

  // Erlaube Zugriff, wenn: public, Name drin, oder Demo-User
  if (isPublic || isNameEntered || isDemo) return children;

  // Sonst: Umleiten
  return <Navigate to="/" replace />;
};

export default NameGuard;
